import { render, staticRenderFns } from "./GetDemoBlock.vue?vue&type=template&id=a208e27e&scoped=true"
import script from "./GetDemoBlock.vue?vue&type=script&lang=ts"
export * from "./GetDemoBlock.vue?vue&type=script&lang=ts"
import style0 from "./GetDemoBlock.vue?vue&type=style&index=0&id=a208e27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a208e27e",
  null
  
)

export default component.exports